import { api } from '../api/api';
import type { LicenseModule } from '../utils/license';

/** Licence of the current planning area, as GET /api/license returns it. */
export interface LicenseInfo {
  tenantUuid: string;
  tenantName: string;
  source: 'LICENSE' | 'LEGACY_SIGNATURE' | 'NONE';
  customer?: string | null;
  modules: LicenseModule[];
  issuedAt?: string | null;
  validUntil?: string | null;
  maintenanceUntil?: string | null;
  expired: boolean;
  daysUntilExpiry?: number | null;
  expiryNotice: boolean;
}

export async function fetchLicense(): Promise<LicenseInfo> {
  const response = await api.get<LicenseInfo>('/api/license');
  return response.data;
}

/** Uploads a new licence key. The backend rejects keys of other planning areas with 400. */
export async function uploadLicense(licenseKey: string): Promise<LicenseInfo> {
  const response = await api.put<LicenseInfo>('/api/license', { licenseKey });
  return response.data;
}
